import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../../utils/api';

export interface ScholarshipPercentageConfig {
  id: number;
  institutionShortName: string;
  minPercent: number;
  maxPercent: number;
  stepInterval: number;
  allowedValues: string | null;
  generatedOptions: number[];
}

interface ScholarshipPercentageConfigResponse {
  statusCode: number;
  message: string;
  data: ScholarshipPercentageConfig;
}

export const GET_SCHOLARSHIP_PERCENTAGE_CONFIG_QUERY_KEY = ['get-scholarship-percentage-config'];

export const useGetScholarshipPercentageConfigQuery = () => {
  const fetchConfig = async (): Promise<ScholarshipPercentageConfigResponse> => {
    return (await api.get('/admin/scholarship/percentage-config'))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<
    ScholarshipPercentageConfigResponse,
    AxiosError<ApiErrorResponse>
  >({
    queryKey: GET_SCHOLARSHIP_PERCENTAGE_CONFIG_QUERY_KEY,
    queryFn: fetchConfig,
  });

  const errorMessage =
    error?.response?.data?.message || error?.message || 'Failed to fetch percentage configuration';

  return {
    percentageConfigData: data?.data,
    isLoading,
    isError,
    errorMessage,
    refetch,
  };
};
